import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';
import type { TimesheetEntry } from '@/types/timesheet';
import type { OrganisationTimesheetSettings } from '@/types/timesheetSettings';

export interface RowDescriptionCellProps {
  entry: TimesheetEntry;
  index: number;
  isReadOnly: boolean;
  isAbsence: boolean;
  organizationSettings: OrganisationTimesheetSettings | undefined;
  onUpdateEntry: (index: number, field: keyof TimesheetEntry, value: unknown) => void;
}

/** Row-level description cell (rendered only in row description mode). */
export function RowDescriptionCell({
  entry,
  index,
  isReadOnly,
  isAbsence,
  organizationSettings,
  onUpdateEntry,
}: RowDescriptionCellProps) {
  return (
    <td className="p-1 sm:p-1.5">
      {isAbsence ? (
        <Textarea
          value={entry.description}
          onChange={() => {}} // No-op for absence entries
          placeholder="Activity description..."
          className="h-9 min-h-9 resize-none text-xs sm:text-sm bg-muted/50 cursor-not-allowed"
          disabled={true}
        />
      ) : (
        <Textarea
          value={entry.description}
          onChange={(e) => onUpdateEntry(index, 'description', e.target.value)}
          placeholder="Activity description..."
          className={cn(
            'h-9 min-h-9 resize-none text-xs sm:text-sm',
            organizationSettings?.requireDescription === 'always' && !entry.description.trim() && !isReadOnly && 'border-destructive/50 focus:border-destructive focus:ring-destructive/30'
          )}
          disabled={isReadOnly}
        />
      )}
    </td>
  );
}
